import 'babel-polyfill';
import Vue from 'vue'
import router from "./router";
import axios from './axios/api';
import App from './App.vue'
import './assets/css/common.css'
import { Toast,Dialog,Loading,} from 'vant'
import cookies from 'vue-cookies'
Vue.prototype.$cookies = cookies

Vue.use(Toast);
Vue.use(Loading);
Vue.use(Dialog);
Vue.prototype.showloading = (msg) => {
   Toast.loading({
      duration: 0, // 持续展示 toast
      message: msg+'...',
      forbidClick: true // 禁用背景点击
   })
}
Vue.prototype.hideloading = () => {
   Toast.clear()
}

Vue.prototype.dialog = (msg) =>{
   Dialog.alert({
      title: 'Tip',
      message: msg,
      confirmButtonText:'OK',
   })
}

Vue.prototype.axios = axios;
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
